<div [attr.aria-busy]="provisionloading">
  <div class="form-group">
    <div class="search-field">
      <tds-icon class="search-field__icon" name="search" size="20px" aria-hidden="true"></tds-icon>
      <input id="txtSearchSpecification" autocomplete="off" type="search" class="form-control"
        placeholder="Search configuration" aria-label="Search configuration" [(ngModel)]="searchspecification" (ngModelChange)="getSortedProvision()" />
    </div>
  </div>
  <tds-table table-id="configuration-table" [verticalDividers]="false" [compactDesign]="true" [responsive]="true" zebra-mode="rows-odd" [noMinWidth]="true">
    <tds-table-header>
      <tds-header-cell cell-key="family" cell-value="Family" custom-width="14%"></tds-header-cell>
      <tds-header-cell cell-key="description" cell-value="Family description" custom-width="26%"></tds-header-cell>
      <tds-header-cell cell-key="current" cell-value="Current configuration" custom-width="26%"></tds-header-cell>
      <tds-header-cell cell-key="new" cell-value="New configuration" custom-width="34%"></tds-header-cell>
    </tds-table-header>
    <tds-table-body>
      <tds-table-body-row *ngFor="let item of displayedProvision; trackBy: trackProvisionItem">
        <tds-body-cell cell-key="family" vertical-align="middle" [cellValue]="item.Type + ' ' + item.Family"></tds-body-cell>
        <tds-body-cell cell-key="description" vertical-align="middle" [cellValue]="item.FamilyDescription || ''"></tds-body-cell>
        <tds-body-cell cell-key="current" vertical-align="middle">
          <span [title]="'Execution: ' + item.Execution">{{ item.ExecutionDescription || item.Execution }}</span>
        </tds-body-cell>
        <tds-body-cell cell-key="new" vertical-align="middle" class="execution-table-cell">
          <conversion-selectconfiguration *ngIf="item.Type === 'FPC'" [fpcfamily]="item.Family"
            [fpcexecution]="item.Execution" [activeComponent]="false" [changes]="changes"
            [selectonce]="true" [type]="item.Type" (selectedexecution)="selectExecution(item, $event)">
          </conversion-selectconfiguration>
        </tds-body-cell>
      </tds-table-body-row>
    </tds-table-body>
  </tds-table>
  <p *ngIf="provisionPipeResult.length === 0" class="configuration-empty">No results</p>
  <nav *ngIf="provisionPipeResult.length > 0" class="configuration-pagination" aria-label="Configuration pages">
    <span role="status">{{ firstVisible }}–{{ lastVisible }} of {{ provisionPipeResult.length }}</span>
    <div>
      <tds-button type="button" size="sm" variant="secondary" text="Previous" [disabled]="page === 1" (click)="showPage(page - 1)"></tds-button>
      <tds-button type="button" size="sm" variant="secondary" text="Next" [disabled]="page === pageCount" (click)="showPage(page + 1)"></tds-button>
    </div>
  </nav>
</div>
